import script from "./HeroView.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroView.vue?vue&type=script&setup=true&lang=js"

import "./HeroView.vue?vue&type=style&index=0&id=67d9a59e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d9a59e"]])

export default __exports__